/**
 * PostReportModal — rapport de report (étape 1 : ventes / achats / notes de crédit / paiements → journal auxiliaire).
 */
import { CheckCircle2, Printer } from "lucide-react";
import { Btn, Modal, money } from "../comptabilite/_shared";

export default function PostReportModal({ report, onClose }) {
  return (
    <Modal title={`Rapport de report — ${report.label}${report.posted > 1 ? "s" : ""}`} sub={`${report.posted} pièce(s) reportée(s) le ${new Date(report.posted_at).toLocaleString("fr-CA")} par ${report.posted_by}. Les écritures correspondantes attendent maintenant le report au grand livre (tuile Journal général).`}
      onClose={onClose} wide testId="post-report-modal"
      footer={<><Btn tone="slate" icon={Printer} onClick={() => window.print()} testId="post-report-print">Imprimer</Btn><Btn icon={CheckCircle2} onClick={onClose} testId="post-report-close">Fermer</Btn></>}>
      <table className="w-full text-sm" data-testid="post-report-table">
        <thead className="bg-slate-50 text-[10px] uppercase tracking-wider text-slate-500"><tr><th className="text-left px-3 py-2 w-24">Date</th><th className="text-left px-2 py-2 w-28">N°</th><th className="text-left px-2 py-2">Tiers / description</th><th className="text-right px-2 py-2 w-32">Montant</th></tr></thead>
        <tbody className="divide-y">
          {report.items.map((i) => (
            <tr key={i.id} data-testid={`post-report-row-${i.id}`}><td className="px-3 py-1.5 font-mono text-xs">{i.date}</td><td className="px-2 py-1.5 font-mono text-xs">{i.number || "—"}</td><td className="px-2 py-1.5">{i.party_name}{i.description && <span className="text-slate-500"> — {i.description}</span>}</td><td className="px-2 py-1.5 text-right font-mono tabular-nums">{money(i.amount)}</td></tr>
          ))}
          <tr className="font-bold bg-slate-50"><td colSpan={3} className="px-3 py-2 text-right">TOTAL</td><td className="px-2 py-2 text-right font-mono tabular-nums" data-testid="post-report-total">{money(report.total)}</td></tr>
        </tbody>
      </table>
      {report.errors?.length > 0 && (
        <div className="bg-rose-50 border border-rose-200 rounded-xl p-3 text-xs text-rose-800" data-testid="post-report-errors">
          <strong>{report.errors.length} pièce(s) non reportée(s) :</strong>
          <ul className="list-disc ml-5 mt-1">{report.errors.map((e, i) => <li key={i}>{e}</li>)}</ul>
        </div>
      )}
    </Modal>
  );
}
